const Legend = ({ items, onHoverStart, onHoverEnd }) => {
    return (
      <div
        style={{
          position: "absolute",
          bottom: 20,
          left: 20,
          backgroundColor: "white",
          padding: "12px",
          borderRadius: "6px",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
          zIndex: 1,
        }}
      >
        <h3 style={{ fontWeight: "bold", marginBottom: "10px" }}>Legend</h3>
        <ul style={{ listStyle: "none", padding: 0 }}>
          {items.map((item) => (
            <li
              key={item.type}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
                cursor: "pointer",
                fontSize: "12px",
              }}
              onMouseEnter={() => onHoverStart(item.type)}
              onMouseLeave={onHoverEnd}
            >
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: item.color,
                  marginRight: "8px",
                }}
              ></span>
              {item.type}
            </li>
          ))}
        </ul>
      </div>
    )
  }
  
  export default Legend